import { ACX_WEB_ENABLE_EH_CONSENT_TEALIUM } from 'constants/featureToggles'
import { SITE_ENVIRONMENTS } from 'constants/websites'
import { getFeatureFlag } from 'utils/featureFlags'
import { isEhConsentTealiumPilotSeededInWindow } from './ehConsentTealiumPilotSeed'

/**
 * EH consent-gated Tealium is piloted on achieve.com only until multi-brand rollout.
 * Toggle: LaunchDarkly `acx-web-enable-eh-consent-tealium` (ADR-014).
 *
 * Server: call `resolveEhConsentTealiumPilotForLayout` from layout before reading this.
 * Client: the layout inline pilot seed (`ehConsentTealiumPilotSeed`) is authoritative when present
 * (emitted only when the server enabled the pilot); it is checked before site env / LD so production
 * bundles that do not inline `NEXT_PUBLIC_SITE_ENVIRONMENT` still skip legacy Tealium.
 */
export function isEhConsentTealiumEnabled() {
  if (typeof window !== 'undefined' && isEhConsentTealiumPilotSeededInWindow()) {
    return true
  }
  if (process.env.NEXT_PUBLIC_SITE_ENVIRONMENT !== SITE_ENVIRONMENTS.ACHIEVE) {
    return false
  }
  return getFeatureFlag(ACX_WEB_ENABLE_EH_CONSENT_TEALIUM) === true
}
